











































































import { Component, Vue } from "vue-property-decorator";
import { apiClient } from "../../api/ApiClient";
import moment from "moment";
import {
  createNotify,
  updateNotify,
  deleteNotify,
  notifyError,
  notifyErrorThrow
} from "@/utils/formHelper";
import TickCross from "@/components/TickCross.vue";
import Enumerable from 'linq';
import validator from 'validator';
import { isSubscriptionValid } from '../../utils/subscriptionHelper';
import camelcase from 'camelcase';

@Component({
  components: {
    TickCross,
  },
})
export default class extends Vue {

  public get moment() {
    return moment;
  }

  public get isSubscriptionValid() {
    return isSubscriptionValid;
  }

  // form
  public get rules() {
    return {
      name: [
        {
          required: true,
          trigger: "blur",
          message: this.$t('form["this field is required"]')
        }
      ],
      customer: [
        {
          required: true,
          trigger: "blur",
          message: this.$t('form["this field is required"]')
        }
      ],
    };
  }

  public get formTitle() {
    switch (this.formState) {
      case "create":
        return this.$t('global["Create"]');
      case "edit":
        return this.$t('global["Edit"]');
      default:
        return "";
    }
  }
  public formState: string = "create";

  // wallet form
  public form: any = {};
  public formVisible = false;

  // transaction form
  public transactionForm: any = {
    customer: {
      account: {},
    },
  };
  public transactionFormVisible = false;

  // table filter
  public username: string = null;
  public showDisabledCustomer = false;
  public orderByColumn: string = null;
  public orderByOrder: string = null;

  // table
  public currentPage = 1;
  public pageSize = 100;
  public total = 0;

  public isTableLoading = false;

  public data: any[] = [];
  public customers: any[] = [];
  public get filteredCustomers() {
    return this.customers.filter(p => p.account.enabled);
  }

  public mounted() {
    this.init();
  }

  // form events
  public onFormCancel() {
    this.formVisible = false;
  }

  public async onFormConfirm() {
    if (this.formState === 'create') {
      await this.onFormCreateConfirm();
    } else {
      await this.onFormEditConfirm();
    }
  }

  public async onFormCreateConfirm() {
    try {
      this.validateForm();
    } catch (e) {
      console.error(e);
      return;
    }

    const loading = this.$loading({});
    try {
      const { data } = await apiClient.postWallet(this.getForm());
      this.formVisible = false;
      createNotify.bind(this)();
    } catch (e) {
      throw e;
    } finally {
      loading.close();
    }

    await this.loadData();
  }

  public async onFormEditConfirm() {
    try {
      this.validateForm();
    } catch (e) {
      console.error(e);
      return;
    }

    const loading = this.$loading({});
    try {
      const { data } = await apiClient.putWallet(this.form.id, this.getForm());
      this.formVisible = false;
      createNotify.bind(this)();
    } catch (e) {
      throw e;
    } finally {
      loading.close();
    }

    await this.loadData();
  }

  // transaction form events
  public async onTransactionCancel() {
    this.transactionFormVisible = false;
  }

  public async onTransactionConfirm() {
    if (this.transactionForm.amount === 0) {
      return;
    }

    const loading = this.$loading({});
    try {
      await apiClient.walletsTransaction(this.transactionForm.id, this.transactionForm);
      this.transactionFormVisible = false;
    } finally {
      loading.close();
    }

    await this.loadWallets();
  }

  // table events
  public async onClickCreate() {
    this.form = {
      allowNegativeBalance: false
    };
    this.clearFormValidations();
    this.formState = "create";
    this.formVisible = true;
  }

  public async onPaginationChange() {
    await this.loadData();
    this.$scrollTo("#data-table");
  }

  public onClickEdit(row) {
    this.form = {
      ... row,
      customer: row.customer.id,
    };

    this.clearFormValidations();
    this.formState = 'edit';
    this.formVisible = true;
  }

  public onCreateTransactionClick(row) {
    this.transactionForm = {
      ... row,
      isTopUp: true,
      amount: 0,
    };

    this.transactionFormVisible = true;
  }

  // sort
  public async tableSortChange({ column, prop, order }) {
    if (prop && order) {
      this.orderByColumn = camelcase(prop.replace('.', '_'));
      this.orderByOrder = order.startsWith("asc") ? "ASC" : 'DESC';
    } else {
      this.orderByOrder = this.orderByColumn = null;
    }
    return this.loadWallets();
  }

  // init / loads
  private async init() {
    await this.loadData();
  }

  private async loadData() {
    await Promise.all([
      this.loadWallets(),
      this.loadCustomers(),
    ]);
  }

  private async loadWallets() {
    this.isTableLoading = true;
    const { data } = await apiClient.wallets({
      take: this.pageSize,
      page: this.currentPage,

      orderByColumn: this.orderByColumn,
      orderByOrder: this.orderByOrder,

      username: this.username,
      showDisabledCustomer: this.showDisabledCustomer,
    });
    this.total = data.count;
    this.data = data.data;
    this.isTableLoading = false;
  }

  private async loadCustomers() {
    const { data } = await apiClient.customers({
      take: Number.MAX_SAFE_INTEGER,
    });
    this.customers = data.data;
  }

  // form
  private validateForm() {
    if (!this.form.customer) {
      notifyErrorThrow.bind(this)("Please select a customer");
    }

    if (!this.form.name) {
      notifyErrorThrow.bind(this)("Please enter name");
    }
  }

  private clearFormValidations() {
    if (this.$refs.form) {
      (this.$refs.form as any).clearValidate();
    }
  }


  private getForm() {
    return {
      ... this.form,
      customer: {
        id: this.form.customer,
      },
    };
  }

}
